"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionValidationSchema = exports.NomenclatureSchema = exports.DocumentsSchema = void 0;
const zod_1 = require("zod");
const atomics_1 = require("../../atomics");
exports.DocumentsSchema = zod_1.z
    .object({
    plantList: atomics_1.arrayOfLangValues,
    rentalAgreement: atomics_1.arrayOfLangValues,
    expertProtocol: atomics_1.arrayOfLangValues,
    landRegister: atomics_1.arrayOfLangValues,
    energyCertificate: atomics_1.arrayOfLangValues,
    utilityReport: atomics_1.arrayOfLangValues,
    investmentBasicInformation: atomics_1.arrayOfLangValues,
    investmentConditions: atomics_1.arrayOfLangValues,
    investmentInformation: atomics_1.arrayOfLangValues,
})
    .partial();
exports.NomenclatureSchema = zod_1.z
    .object({
    rentalIncomeTitle: atomics_1.arrayOfLangValues,
    rentalIncome: atomics_1.arrayOfLangValues,
    managementFee: atomics_1.arrayOfLangValues,
    liquidityReserve: atomics_1.arrayOfLangValues,
    total: atomics_1.arrayOfLangValues,
    expectedYieldDisclaimer: atomics_1.arrayOfLangValues,
    documents: exports.DocumentsSchema,
})
    .partial();
exports.DescriptionValidationSchema = zod_1.z
    .object({
    title: zod_1.z.string(),
    propertySellingPoints: (0, atomics_1.sanitzedString)(),
    propertyHighlight: zod_1.z.string(),
    propertyDetails: (0, atomics_1.sanitzedString)(),
    propertyQuote: zod_1.z.string(),
    locationDetails: (0, atomics_1.sanitzedString)(),
    districtDetails: zod_1.z.string(),
    cityDetails: (0, atomics_1.sanitzedString)(),
    rentalDetails: (0, atomics_1.sanitzedString)(),
    floorPlanDetails: zod_1.z.string(),
    investmentDetails: (0, atomics_1.sanitzedString)(),
    investmentDetailsAddition: (0, atomics_1.sanitzedString)(),
    securityDetails: zod_1.z.string(),
    taxInformation: zod_1.z.string(),
    powerplantPictureTitle: zod_1.z.string(),
    powerplantPictureDetails: zod_1.z.string(),
    moduleType: zod_1.z.string().optional(),
    nominalPowerPerModule: zod_1.z.string().optional(),
    nomenclature: exports.NomenclatureSchema,
    overview: zod_1.z.string().optional(),
})
    .partial();
//# sourceMappingURL=descriptions.js.map